import React from 'react';
import ContentLoader from 'react-content-loader';
import * as lib from '~/dependencies';

const Line = ({ size, height }) => {
  const width = String(size);
  const minHeight = height;

  return (
    <div style={{ width: Number(size), height: minHeight, marginBottom: 3 }}>
      <ContentLoader
        height={minHeight}
        width={width}
        speed={1}
        style={{ width: Number(size) }}>
        <rect x="0" y="0" rx="5" ry="5" width={width} height={minHeight} />
      </ContentLoader>
    </div>
  );
};

export default Line;

Line.defaultProps = {
  size: 100,
  height: 15,
};

Line.propTypes = {
  size: lib.PropTypes.string,
  height: lib.PropTypes.number,
};
